import { render, staticRenderFns } from "./AppointmentAvailabilitySettings.vue?vue&type=template&id=57b89942&scoped=true&"
import script from "./AppointmentAvailabilitySettings.vue?vue&type=script&lang=ts&"
export * from "./AppointmentAvailabilitySettings.vue?vue&type=script&lang=ts&"
import style0 from "./AppointmentAvailabilitySettings.vue?vue&type=style&index=0&id=57b89942&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b89942",
  null
  
)

export default component.exports